import { render, staticRenderFns } from "./Timeline_new.vue?vue&type=template&id=b8a94400"
import script from "./Timeline_new.vue?vue&type=script&lang=js"
export * from "./Timeline_new.vue?vue&type=script&lang=js"
import style0 from "./Timeline_new.vue?vue&type=style&index=0&id=b8a94400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports